import _ from 'lodash';

import { PrismWidgetType, SigningSignerType } from 'constants/formBuilder';
import { fontFamilyMap } from 'constants/options';

export const setTableStylesToContent = content => {
  return content
    .replace(
      new RegExp('<figure', 'ig'),
      '<figure style="display: table; position: relative; margin: 30px auto 14px auto;" ',
    )
    .replace(
      new RegExp('<table', 'ig'),
      '<table style="display: table; box-sizing: border-box; border-collapse: collapse; border-spacing: 0; width: 100%; height: 100%; border: 1px double #b3b3b3;" ',
    )
    .replace(
      new RegExp('<tbody', 'ig'),
      '<tbody style="display: table-row-group; vertical-align: middle; border-color: inherit;" ',
    )
    .replace(
      new RegExp('<tr', 'ig'),
      '<tr style="display: table-row; vertical-align: inherit; border-color: inherit;" ',
    )
    .replace(
      new RegExp('<td', 'ig'),
      '<td style="display: table-cell; vertical-align: inherit; min-width: 28px; padding: 6px; border: 1px solid #bfbfbf;" ',
    );
};

export const replaceFontFamily = content => {
  return content.replace(/font-family:\s*([^;]+);/gi, (match, currentFont) => {
    const trimmedFont = currentFont.trim();
    const targetFont = fontFamilyMap[trimmedFont];

    return targetFont ? `font-family: ${targetFont.name};` : match;
  });
};

export const getIsFormContentUnchanged = ({
  isPrismFormEditorEnabled,
  content,
  template,
  baselineJson,
  documentJson,
}) => (isPrismFormEditorEnabled ? _.isEqual(baselineJson, documentJson) : content === template);

export const getIsAllBorrowersSignerPresent = documentJson =>
  _.some(
    documentJson?.nodes,
    ({ attributes }) =>
      attributes?.widgetType === PrismWidgetType.SIGNATURE &&
      attributes?.dataHellosignSigner === SigningSignerType.ALL_BORROWERS,
  );
